// extracted by mini-css-extract-plugin
export default {"password-input":"confirm-reset-password_password-input__I69Hm","passwordRequirements":"confirm-reset-password_passwordRequirements__-PA+U"};